import { browserApi } from 'lib/httpClient';
import { GetEventDataParams } from './getEventData';
import { EventDataResponse } from 'eventDomainData';

export async function getEventDataFromBff({
  eventId,
  owner
}: GetEventDataParams) {
  return browserApi.get<EventDataResponse>('/event-data', {
    params: {
      eventId,
      owner
    }
  });
}
